import CookieManager from '../client-js';

export default ({ app }, inject) => {
  inject('cookieManager', new CookieManager(app.$cookies));
};
